function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "21.978"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_1428",
  "data-name": "Rectangle 1428",
  fill: "#fff",
  d: "M0 0h22v21.978H0z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3841",
  "data-name": "Group 3841",
  clipPath: "url(#clip-path)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1163",
  "data-name": "Path 1163",
  d: "M19.758 6.44v10.843a.49.49 0 01-.169.387q-2.115 2.085-4.227 4.175a.453.453 0 01-.284.128q-7.466.009-14.931.005H0V2.26h15.6c-.293.3-.563.58-.846.848-.047.044-.155.032-.235.032H.9v17.927h13.431V16.6h4.532v-.3-8.812a.468.468 0 01.15-.373c.238-.226.461-.468.69-.7l.058.024m-4.52 14.209l.048.029 3.074-3.17h-3.125z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1164",
  "data-name": "Path 1164",
  d: "M10.238 12.665l-.891-.9 8.5-8.5c.294.292.6.6.9.9l-8.509 8.509"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1165",
  "data-name": "Path 1165",
  d: "M20.394 4.418l-2.816-2.813L19.18 0 22 2.823l-1.606 1.6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1166",
  "data-name": "Path 1166",
  d: "M5.014 15.306a12.165 12.165 0 011.231.272 1.777 1.777 0 011.282 1.2 2.053 2.053 0 01-1.377 2.441 1.889 1.889 0 01-2.376-1.305A2.589 2.589 0 014 16.131l.139-.3c0-.005 0-.014-.01-.044-.337.025-.678.044-1.017.079-.169.018-.31 0-.341-.188s.107-.255.259-.266c.41-.029.82-.052 1.23-.063a.328.328 0 00.292-.154c.268-.368.547-.728.822-1.091.1-.135.221-.253.388-.115s.066.275-.037.405c-.239.3-.474.611-.709.916m2.1 2.142a1.267 1.267 0 00-.773-1.352 3.832 3.832 0 00-1.543-.3.219.219 0 00-.164.111 6.1 6.1 0 00-.417 1.007 1.465 1.465 0 002.068 1.759 1.489 1.489 0 00.833-1.229"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1167",
  "data-name": "Path 1167",
  d: "M8.627 11.09l-.257-.248L16.913 2.3l.234.27-8.52 8.52"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1168",
  "data-name": "Path 1168",
  d: "M19.469 4.8l.259.265-8.558 8.564-.237-.287L19.469 4.8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1169",
  "data-name": "Path 1169",
  d: "M6.926 15.043L8 11.161c.957.959 1.894 1.9 2.862 2.866L6.984 15.1l-.058-.062m1.315-3.015c-.116.391-.234.781-.345 1.172a.167.167 0 00.034.136c.244.252.491.5.744.744a.2.2 0 00.155.049c.392-.108.78-.226 1.154-.336l-1.742-1.76"
}))));